import { Card } from "@mui/material";
import React from "react";
export const FCard = ({ children, onClick }) => {
    return (React.createElement(Card, { onClick: onClick, sx: {
            cursor: onClick ? "pointer" : "default",
            "&:hover": onClick
                ? {
                    backgroundColor: "action.hover",
                }
                : {},
        } }, children));
};
export { MetricCard } from "./MetricCard";
